import { NgModule } from '@angular/core';
import { DocBoxTabbedModalComponent } from './docbox-tabbed-modal.component';
import { DocBoxNotificationHistoryComponent } from './notification-history/docbox-notification-history.component';
import { DocBoxNotificationHistoryDetailComponent } from './notification-history/notification-history-detail/notification-history-detail.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PaceCoreModule } from '@evorait/pace-core';
import { SharedModule } from '../shared/shared.module';
import { DocBoxFreeSearchComponent } from './notification-history/docbox-freesearch/docbox-free-search.component';
import { PaceForms2Module } from '@evorait/pace-forms';
import { LetDirective } from '@ngrx/component';

@NgModule({
    declarations: [
        DocBoxTabbedModalComponent,
        DocBoxNotificationHistoryComponent,
        DocBoxNotificationHistoryDetailComponent,
        DocBoxFreeSearchComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        TooltipModule,
        TabsModule,
        TranslateModule.forChild(),
        PaceCoreModule.forChild(),
        PaceForms2Module.forChild(),
        LetDirective,
    ],
    exports: [],
})
export class DocBoxTabbedModalModule {}
